import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '@contexts/AuthContext';
import { VoiceRecordingsProvider } from '@contexts/VoiceRecordingsContext';
import { BaseLayout } from '@layouts/BaseLayout';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import { VoiceRecordingContainer } from './components/VoiceRecordingContainer';
export const Home = () => {
    const { isAuthenticated, isLoading: isAuthLoading, error: authError, initAuthentication, } = useAuth();
    const hasAttemptedAuth = useRef(false);
    useEffect(() => {
        // Only authenticate once
        if (hasAttemptedAuth.current)
            return;
        const authenticateFromUrl = async () => {
            hasAttemptedAuth.current = true;
            // Get token from URL query params
            const urlParams = new URLSearchParams(window.location.search);
            const externalToken = urlParams.get('token');
            initAuthentication(externalToken);
        };
        authenticateFromUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(BaseLayout, { children: (() => {
            if (isAuthLoading) {
                return (_jsx(Box, { flex: 1, display: "flex", justifyContent: "center", alignItems: "center", children: _jsx(CircularProgress, {}) }));
            }
            if (authError || !isAuthenticated) {
                return (_jsx(Typography, { variant: "body1", color: "error", sx: { margin: 'auto' }, children: "Authentication failed. Please refresh the page to continue." }));
            }
            return (_jsx(VoiceRecordingsProvider, { children: _jsx(VoiceRecordingContainer, {}) }));
        })() }));
};
